import pic1 from '../imgs/1.jpg';
import {randNum, randStar} from '../utils';

const properties = [
    {
        address: '160 Flemington Rd',
        room_count: 3,
        img: pic1,
        price: 2300
    },
    {
        address: '778 Sheppard Ave W',
        room_count: 2,
        img: 'https://condos.ca/public/condo_listing/2d/29/95/02/28e0597_0cf4.jpg',
        price: 2300
    },
    {
        address: '#1507 -155 BEECROFT RD',
        room_count: 1,
        img: 'https://cdn.realtor.ca/listing/TS636870253599070000/reb82/highres/1/c4370461_9.jpg',
        price: 2000
    },
    {
        address: '#611 -30 HARRISON GARDEN BLVD',
        room_count: 3,
        img: 'https://cdn.realtor.ca/listing/TS636862715560270000/reb82/highres/0/c4363260_3.jpg',
        price: 1900
    },
    {
        address: '21 WILLOWFIELD MEWS',
        room_count: 4,
        img: 'https://cdn.realtor.ca/listing/TS636845788700630000/reb82/highres/2/e4349402_6.jpg',
        price: 750
    }
]

const users = [
    {
        id: 0,
        firstName: 'Abbie',
        lastName: 'Hunt',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 1,
        firstName: 'Tom',
        lastName: 'Gaziano',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 2,
        firstName: 'Tiffany',
        lastName: 'Marasini',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 3,
        firstName: 'Elsa',
        lastName: 'Yamane',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 4,
        firstName: 'Mike',
        lastName: 'Laski',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 5,
        firstName: 'Rachel',
        lastName: 'Bede',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 6,
        firstName: 'Jerry',
        lastName: 'Casto',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 7,
        firstName: 'Larry',
        lastName: 'Regan',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 8,
        firstName: 'Henry',
        lastName: 'Bellini',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 9,
        firstName: 'Bob',
        lastName: 'Sauer',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 10,
        firstName: 'Charles',
        lastName: 'Patrick',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 11,
        firstName: 'Steve',
        lastName: 'Horrell',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
    {
        id: 12,
        firstName: 'Annie',
        lastName: 'Popiel',
        ver: randNum(10),
        rec: randNum(),
        star: randStar()
    },
]

export {users, properties}